if (!customElements.get('wd-product-variant-picker')) {
class WD_VariantOption extends HTMLElement {
  /** build the new url based on the selected options */
  static update_url() {
    const url = new URL(`${window.location.origin}/products/${window.current_product.handle}`);
    document.querySelectorAll('wd-product-variant-picker input[type="radio"]:checked').forEach((input) => {
      if (!input.value)
        return;
      if (input.name == "handle")
        url.pathname = `/products/${input.dataset.handle}`;
      else
        url.searchParams.append(input.name, input.value);
    })
    window.history.replaceState({}, '', url.toString());
  }
 
  /** `data-price` / `base_price` are major currency units (Liquid `| divided_by: 100`). Uses `FoxTheme.Currency.formatMoney` when available. */
  /** @param {number} amountMajor */
  static formatMoneyMajor(amountMajor) {
    const cents = Math.round(Number(amountMajor) * 100);
    const tpl = window.current_product?.money_format;
    if (tpl && typeof tpl === 'string')
      return tpl.replaceAll("{{amount}}", Number(amountMajor).toLocaleString());
    return String(amountMajor);
  }

  /** Hebrew strings aligned with `wd-product-variant-options.liquid` (תוספת / פחות). @param {number} diffMajor */
  static formatDynamicAfterDiff(diffMajor) {
    if (diffMajor == null || Number.isNaN(diffMajor)) return null;
    if (Math.abs(diffMajor) < 0.005) return null;
    const p = WD_VariantOption.formatMoneyMajor(Math.abs(diffMajor));
    if (diffMajor > 0)
      return `(תוספת ${p})`;
    const pNeg = String(p).replace(/ /g, '-');
    return `(${pNeg} פחות)`;
  }

  /** Recomputes `label[after]` for every picker that has `.wd-dynamic-price`, then refreshes custom-select UI. */
  static refreshAllDynamicPriceAfters() {
    document.querySelectorAll('wd-product-variant-picker').forEach((el) => {
      if ('refreshDynamicPriceAfter' in el)
        /** @type {WD_VariantOption} */ (el).refreshDynamicPriceAfter();
    });
  }

  /** @type {HTMLInputElement[]} */
  radio_btns
  /** @type {"color" | "handle" | "railing" | "m1" | "m2" | "m3" | "m4" | "m5" | "shelves" | "drawers" | "extension?"} same param as the one in the wd-product-variant-options snippet*/
  param

  /** Set when this row uses the custom listbox UI; `destroy()` on teardown. */
  /** @type {{ destroy: () => void, syncFromRadios: () => void, open: () => void, close: () => void } | null} */
  customSelectApi = null

  connectedCallback() {
    // Only radios inside this picker's option row (never mix with other pickers).
    this.radio_btns = this.querySelectorAll(':scope .wd-product-variant-options input[type="radio"]');
    this.param = this.getAttribute('param');

    this.bindEvents();
    this.setSelectedOptionFromUrl();
    // ETZ-963 / ETZ-974: show selected color name on first load (drawer colors + sibling color swatches).
    const checked = [...this.radio_btns].find((btn) => btn.checked);
    if (checked) this.updateSelectedLabel(checked);
    this.transformToDropdown();
    this.refreshDynamicPriceAfter();
  }


  /** Meaningful choice count: excludes the extra "none" row when `data-default-none` is set. */
  optionCount() {
    return this.radio_btns.length;
  }

  /** binds the events to the radio buttons */
  bindEvents() {
    // register radio button events
    this.radio_btns.forEach((btn, index) => {
      if (this.param == 'color' && btn.checked)
        this.handleColor_n_RailingLink(btn);

      btn.addEventListener('change', () => this.selectOption(btn));
      btn.closest('label').addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          btn.checked = true;
          this.selectOption(btn);
        }
      });
      // if handle param(sibling products), preload the section on hover or Xs into page lifecycle
      if (this.param == 'handle') {
        function preloadSiblingProduct() {
          fetch(`${window.location.origin}/products/${btn.dataset.handle}?section_id=${window.current_product.sectionId}`, { preload: true });
        }
        btn.closest('label').addEventListener('mouseenter', preloadSiblingProduct);
        // if only a few size options, preload after 15sec
        setTimeout(preloadSiblingProduct, 5_000 + index * 500);
      }
    });
  }

  /** Applies `?param=value` from the URL to this row’s radios (if param present). */
  setSelectedOptionFromUrl() {
    const url = new URL(window.location.href);
    const selected_option = url.searchParams.get(this.param);
    if (selected_option) {
      this.radio_btns.forEach((btn) => {
        if (btn.value == selected_option) {
          btn.checked = true;
          this.updateSelectedLabel(btn);
        }
        // update the linked railing option to match main color (from default selected or from url)
        if (btn.checked && this.param == 'color') {
          this.handleColor_n_RailingLink(btn);
        }
      });
    }
  }

  /** @param {HTMLInputElement} btn */
  async selectOption(btn) {
    // update the label that indicates the selected option
    this.updateSelectedLabel(btn);

    // handle color and railing selection link
    if (this.param == 'color')
      this.handleColor_n_RailingLink(btn);

    // if handle param(sibling products), preload the section on hover
    if (this.param == 'handle') {
      const id = `shopify-section-${window.current_product.sectionId}`

      // toggle on if later on we want skeleton loader
      const showPriceSkeleton = false;

      if (showPriceSkeleton)
        document.getElementById(id).querySelectorAll(".wd-price, .installments_price, .installments_count").forEach(price => {
          price.classList.add("skeleton", "skeleton-text", "auto");
        });

      const response = await fetch(`${window.location.origin}/products/${btn.dataset.handle}?section_id=${window.current_product.sectionId}`, { preload: true });
      if (!response.ok) {
        window.location.assign(`/products/${btn.dataset.handle}`);
        return;
      }
      const html = await response.text();
      const fragment = document.createRange().createContextualFragment(html);

      function transition() {
        document.getElementById(id).replaceWith(fragment.getElementById(id));
        if (showPriceSkeleton)
          document.getElementById(id).querySelectorAll(".wd-price, .installments_price, .installments_count").forEach(price => {
            price.classList.add("skeleton", "skeleton-text", "auto");
            setTimeout(() => {
              price.classList.remove("skeleton", "skeleton-text", "auto");
            }, 5);
          })
      }

      // use transition api with fallback to older browsers
      if (document.startViewTransition) {
        document.startViewTransition(transition);
      } else {
        transition();
      }
    }



    WD_VariantOption.update_url();
    WD_VariantOption.refreshAllDynamicPriceAfters();

    // dispatch the variantChange event to update the price
    document.dispatchEvent(new CustomEvent('variantChange', { bubbles: true }));
  }

  /** Sets `after` on labels for `input.wd-dynamic-price` vs this row’s checked `data-price`; syncs custom select trigger + options. */
  refreshDynamicPriceAfter() {
    const inputs = this.querySelectorAll(':scope .wd-product-variant-options input.wd-dynamic-price');
    if (!inputs.length) {
      this.customSelectApi?.syncFromRadios();
      return;
    }
    const checked = this.querySelector(':scope .wd-product-variant-options input[type="radio"]:checked');
    const baseMajor = Number(checked?.dataset?.price ?? 0);
    inputs.forEach((input) => {
      const lab = input.closest('label');
      if (!lab) return;
      const optMajor = Number(input.dataset?.price ?? 0);
      const diff = optMajor - baseMajor;
      const text = WD_VariantOption.formatDynamicAfterDiff(diff);
      if (text) lab.setAttribute('after', text);
      else lab.removeAttribute('after');
    });
    this.customSelectApi?.syncFromRadios();
  }

  /** updates the label that indicates the selected option */
  /** @param {HTMLInputElement} btn */
  updateSelectedLabel(btn) {
    // Drawer color row (`param=color`) or sibling products rendered as color swatches (`handle` + `.wd-swatch--color`).
    const isColorSwatch = this.param == 'color' || Boolean(this.querySelector('.wd-swatch--color'));
    if (!isColorSwatch) return;

    const colorName = btn.getAttribute('textValue');
    if (!colorName) return;

    const label = this.querySelector('.wd-product-variant-options-label');
    if (!label) return;
    label.textContent = label.dataset.baseLabel + ': ' + colorName;
  }

  /** on color change, update the visible railing option that has the same color value. handles railing selection state
   * @param {HTMLInputElement} selected_color_btn */
  handleColor_n_RailingLink(selected_color_btn) {
    // Stacked galleries listen in `wd-scripts-product-media-gallery-by-color.js`
    window.dispatchEvent(new CustomEvent('colorChange', { bubbles: true, detail: { colorId: selected_color_btn.value } }));

    const selected_color = selected_color_btn.getAttribute('textValue');
    // get railing options
    /** @type {HTMLInputElement[]} */
    const railing_options = Array.from(document.querySelectorAll('input[name="railing"]'));
    /** @type {HTMLInputElement|undefined} */
    const current_selected_railing_option = railing_options.find(btn => btn.checked);
    // hide & reset all railing options except "none selection"
    railing_options.forEach(btn => {
      if (!btn.value) {
        btn.checked = true;
        return;
      }
      btn.closest("label").classList.add('hidden', 'visually-hidden')
      btn.checked = false
    });
    // get the railing option that has the same color value
    const railing_option_to_show = railing_options.find(btn => btn.getAttribute('colorValue') == selected_color)

    // if we match value
    if (railing_option_to_show) {
      railing_option_to_show.closest("label").classList.remove('hidden', 'visually-hidden');
      // if the previous selected was NOT "none" update the new matched option to be selected
      if (current_selected_railing_option && current_selected_railing_option.value) {
        railing_option_to_show.checked = true;
      }
    }
  }

  /** if there are more than 3 options, transform the variant picker to a dropdown (from simple radio buttons)
   * while keeping the exact same radio logic (change view to be dropdown)
   */
  transformToDropdown() {
    // Dropdown only when this row has *more than three* meaningful choices (see `optionCount`).
    if (this.optionCount() <= 3 || ["color"].includes(this.param)) return;
    // if handle param and its rendered as color swatch, don't transform to dropdown (its color siblings)
    if (this.param == 'handle' && this.querySelector(".wd-swatch--color")) return;
    // if railing param and the color swatch is present else where, don't transform to dropdown (regular y/n toggle)
    if (this.param == 'railing' && document.querySelector("wd-product-variant-picker .wd-swatch--color")) return;
    if (typeof globalThis.WD_CustomSelect?.mount !== 'function') return;
    const optionsRoot = this.querySelector('.wd-product-variant-options');
    if (!optionsRoot || this.customSelectApi) return;

    optionsRoot.style.display = 'contents';

    this.classList.add('wd-product-variant-picker--dropdown');
    const heading = this.querySelector('.wd-product-variant-options-label');
    this.customSelectApi = globalThis.WD_CustomSelect.mount(this, {
      radios: this.radio_btns,
      anchor: optionsRoot,
      labelledBy: heading?.id || undefined,
    });
    // Keep one keyboard path: custom trigger + listbox (radios stay for logic / SR backup).
    for (const btn of this.radio_btns) {
      btn.tabIndex = -1;
      btn.closest('label')?.setAttribute('tabindex', '-1');
    }
  }
}

customElements.define('wd-product-variant-picker', WD_VariantOption);

// generic logic for whole page
(function () {
  let price_update_timeout = null;
  // listen and debounce the price update (on initial load there are multiple calls BEFORE all option are properly updated)
  document.addEventListener('variantChange', _ => {

    clearTimeout(price_update_timeout);
    // calc new total price
    price_update_timeout = setTimeout(() => {
      let totalPrice = Number(window.current_product.base_price ?? 0);
      let totalCompare = Number(window.current_product.base_compare_at ?? window.current_product.base_price ?? 0);
      document.querySelectorAll('wd-product-variant-picker input[type="radio"]:checked').forEach((input) => {
        // ignore handle — base product price is already in base_price / base_compare_at
        if (input.name == "handle" || !input.value)
          return;
        const optionPrice = Number(input.dataset.price ?? 0);
        const optionComparePrice = Number(input.dataset.comparePrice ?? 0);
        totalPrice += optionPrice;
        totalCompare += optionComparePrice > 0 ? optionComparePrice : optionPrice;
      });
      if (window.WDPriceFormat?.updateProductPrices) {
        window.WDPriceFormat.updateProductPrices(totalPrice, totalCompare);
      }
      document.dispatchEvent(new CustomEvent('priceChange', {
        bubbles: true,
        detail: { totalPrice, totalCompare },
      }));
      WD_VariantOption.refreshAllDynamicPriceAfters();
    }, 30);
  });

  // fire initially after the DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.dispatchEvent(new CustomEvent('variantChange'));
    });
  } else {
    document.dispatchEvent(new CustomEvent('variantChange'));
  }
})();
}

globalThis.WD_VariantOption = customElements.get('wd-product-variant-picker');